import React from 'react';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';
import { AdvancedFormReturnType } from '../../../../helpers/form/useAdvancedForm.ts';
import { Form } from './AddDeviceModal.tsx';
import styles from './ModalStyles.module.scss';
import clsx from 'clsx';
import { RadioButton } from '../../../../components/uikit/RadioButton.tsx';
import { useWatch } from 'react-hook-form';
import { Input } from '../../../../components/uikit/inputs/Input.tsx';
import { Checkbox } from '../../../../components/uikit/inputs/Checkbox.tsx';
import { Tip } from '../../../../components/uikit/Tip.tsx';
import { ReasonForReturn } from '../../../../services/api/api-client.types.ts';

type OwnProps = {
  form: AdvancedFormReturnType<Form>;
};

export const AdditionalInfoScreen = (props: OwnProps) => {
  const i18n = useScopedTranslation('Page.CreateRepairRequest');

  const { form } = props;

  const [replacementReceived, workRequiredImmediately, selectedReasons] =
    useWatch({
      control: form.control,
      name: [
        'replacementReceived',
        'workRequiredImmediately',
        'selectedReasons',
      ],
    });

  const isReturnForCreditSelected = !!selectedReasons.find(
    (reason) => reason.key === ReasonForReturn.ReturnForCredit,
  );

  return (
    <div>
      {isReturnForCreditSelected && (
        <div>
          <div className={clsx(styles.addDeviceLabel, styles.marginBottom14)}>
            {i18n.t('replacement_already_received')}
          </div>
          <div className={clsx(styles.rowContainer, styles.marginBottom48)}>
            <RadioButton
              name={'replacementReceived'}
              title={i18n.t('yes')}
              value={'received'}
              className={styles.marginRight84}
              checked={replacementReceived === true}
              onChange={() =>
                form.setValue('replacementReceived', true, {
                  shouldDirty: true,
                })
              }
            />
            <RadioButton
              name={'replacementReceived'}
              value={'not_received'}
              title={i18n.t('no')}
              checked={replacementReceived === false}
              onChange={() =>
                form.setValue('replacementReceived', false, {
                  shouldDirty: true,
                })
              }
            />
          </div>
        </div>
      )}
      <Input
        {...form.register('repairLimitEuro')}
        topHelperText={i18n.t('repair_without_estimate')}
        topRightHelperText={i18n.t('optional')}
        fullWidth
        containerClassName={clsx(
          styles.marginBottom40,
          !isReturnForCreditSelected && styles.marginTop20,
        )}
        type={'number'}
      />
      <Checkbox
        actionText={i18n.t('without_cost_estimate')}
        isChecked={workRequiredImmediately}
        onChange={(e) =>
          form.setValue('workRequiredImmediately', e.target.checked, {
            shouldDirty: true,
          })
        }
        actionTextClassName={styles.marginTopMinus2}
        containerClassName={clsx(styles.flexStart, styles.marginBottom32)}
      />
      <div
        className={clsx(
          styles.rowContainer,
          styles.spaceBetween,
          styles.marginBottom4,
        )}
      >
        <div className={styles.addDeviceLabel}>{i18n.t('ticket_id')}</div>
        <Tip tooltipText={i18n.t('attach_ticket_id')} />
      </div>
      <Input {...form.register('ticketId')} fullWidth />
    </div>
  );
};
